import { adminGuard } from "./guards.js";

const AnnouncementEdit = () => import("../Views/Announcement/AnnouncementEdit.vue");
const AnnouncementCreate = () => import("../Views/Announcement/AnnouncementCreate.vue");
const AnnouncementList = () => import("../Views/Announcement/AnnouncementList.vue");

export const announcementRoutes = [
    {
        path: "/announcements/edit/:id",
        name: "announcements.edit",
        component: AnnouncementEdit,
        beforeEnter: adminGuard,
        meta: {
            menu: {
                parent: 'announcements',
                child: null
            },
            breadcrumb: {
                title: "Bandeaux d'annonce",
                nav: {
                    all: {
                        active: "Modification",
                        inactive: [{
                            title: "Tous les bandeaux",
                            link: { name: 'announcements.list' }
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/announcements/create",
        name: "announcements.create",
        component: AnnouncementCreate,
        beforeEnter: adminGuard,
        meta: {
            menu: {
                parent: 'announcements',
                child: null
            },
            breadcrumb: {
                title: "Bandeaux d'annonce",
                nav: {
                    all: {
                        active: "Création",
                        inactive: [{
                            title: "Tous les bandeaux",
                            link: { name: 'announcements.list' }
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/announcements",
        name: "announcements.list",
        component: AnnouncementList,
        beforeEnter: adminGuard,
        meta: {
            menu: {
                parent: 'announcements',
                child: null
            },
            breadcrumb: {
                title: "Bandeaux d'annonce",
                nav: {
                    all: {
                        active: "Tous les bandeaux",
                        inactive: []
                    }
                }
            }
        },
    }
];
